<template>
    <double-cta-section
        class="double-cta-section-module"
        :items="formattedCtas"
    />
</template>

<script>
    import DoubleCtaSection from '../../../organisms/DoubleCtaSection/DoubleCtaSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'double-cta-section-module',

        components: { DoubleCtaSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Format the api data for the CtaSection component.
             *
             * @returns {Array}
             */
            formattedCtas() {
                return [
                    {
                        title: this.attributes.left_cta_title,
                        description: this.attributes.left_cta_text,
                        image: formatMediaObject
                            .call(this, this.attributes.left_cta_image),
                        buttons: [
                            {
                                id: 'left_button_1',
                                to: this.attributes.left_cta_button_1_link
                                    ?.uri,
                                href: this.attributes.left_cta_button_1_link_external,
                                name: this.attributes.left_cta_button_1_text,
                            },
                            {
                                id: 'left_button_2',
                                to: this.attributes.left_cta_button_2_link
                                    ?.uri,
                                href: this.attributes.left_cta_button_2_link_external,
                                name: this.attributes.left_cta_button_2_text,
                            },
                        ].filter(({ to, href, name }) => (href || to) && name),
                    },
                    {
                        title: this.attributes.right_cta_title,
                        description: this.attributes.right_cta_text,
                        image: formatMediaObject
                            .call(this, this.attributes.right_cta_image),
                        buttons: [
                            {
                                id: 'right_button_1',
                                to: this.attributes.right_cta_button_1_link
                                    ?.uri,
                                href: this.attributes.right_cta_button_1_link_external,
                                name: this.attributes.right_cta_button_1_text,
                            },
                            {
                                id: 'right_button_2',
                                to: this.attributes.right_cta_button_2_link
                                    ?.uri,
                                href: this.attributes.right_cta_button_2_link_external,
                                name: this.attributes.right_cta_button_2_text,
                            },
                        ].filter(({ to, href, name }) => (href || to) && name),
                    },
                ];
            },
        },
    };
</script>
